import { store } from "~/state/store";
import { node, icon } from "~/util/dom";
import { getDetail } from "~/util/providers/review";
import { setLike } from "~/util/providers/like";
import { IReviewItemLike } from "./interfaces";
import { _ } from "~/i18n";

interface IFirmLike {
	id: string;
	data: IReviewItemLike;
	index?: number;
	commentsSync?: boolean;
	disabled?: boolean;
	detail: {
		source: string;
		id: number;
		typeId: number;
	};
	analytics?: object;
}

// signal @firmreview-comments-likeupdate
export default class FirmLike {
	_opts: IFirmLike;

	_dom: {[key: string]: HTMLElement};

	_request: boolean;

	constructor(optsArg: IFirmLike) {
		const opts = {
			id: "",
			data: null,
			index: 0, // pozice itemu vuci ostatnim
			commentsSync: false, // synchronizovat like s komentari v detailu
			disabled: false,
			detail: {
				source: "",
				id: 0,
				typeId: 0,
			},
			analytics: {},
			...optsArg,
		};

		this._opts = opts;
		this._dom = {};
		this._request = false;

		this._build();
		this.data = this._opts.data;
	}

	get container() {
		return this._dom.container;
	}

	get id() {
		return this._opts.id;
	}

	set data(data: IReviewItemLike) {
		this._opts.data = data;

		this._dom.container.classList[this._opts.data?.voted ? "add" : "remove"]("voted");
		this._dom.likeValue.textContent = (this._opts.data?.count || 0).toString();
	}

	_build() {
		const likeBtn = node("button", { className: "firm-like-btn" });

		likeBtn.appendChild(icon("heart"));
		likeBtn.appendChild(node("span", { className: "like-txt", textContent: _("photo.like") }));
		const likeValue = node("span", { className: "like-value" });

		likeBtn.appendChild(likeValue);
		likeBtn.setAttribute("data-log-ignore", "true");
		likeBtn.addEventListener("click", () => {
			this._click();
		});

		if (this._opts.disabled) {
			likeBtn.setAttribute("disabled", "true");
		} else {
			likeBtn.removeAttribute("disabled");
		}

		// vlastni hodnoceni
		this._dom.container = likeBtn;
		this._dom.likeValue = likeValue;
	}

	_click() {
		const { user } = store.getState().user;

		if (user.state === "green") {
			this._sendLike();
		} else {
			// musime se prihlasit
			Mapy.getComponent("login").open({
				analyticsData: this._getLogData({
					loginOrigin: "reviewsLike",
					section: "reviews",
					type: "like",
				}),
				motivation: "review",
			}).then(() => {
				getDetail({
					source: this._opts.detail.source,
					id: this._opts.detail.id,
				}).then(data => {
					if (data.myReview) {
						this._dom.container.setAttribute("disabled", "true");
					} else {
						this._sendLike();
					}
				}, () => { /**/ });
			});
		}
	}

	_sendLike() {
		if (this._request) {
			return;
		}

		this._request = true;

		const like = !this._opts.data || !this._opts.data.voted;

		// analytika
		this._log("click", {
			text: "heart-button",
			type: like ? "like" : "dislike",
		});

		setLike(this._opts.id, like).then(data => {
			this.data = {
				...data.data,
				id: this._opts.id,
			};
			this._request = false;
			// signal pro sync u komentaru
			if (this._opts.commentsSync) {
				window.dispatchEvent(new CustomEvent("firmreview-comments-likeupdate", {
					// novy objekt pro jistotu, pak dame data, id se muze pak prepsat z data.
					detail: {
						id: this._opts.id,
						...data.data,
					},
				}));
			}
		}, () => {
			this._request = false;
		});
	}

	_getLogData(data) {
		return {
			id: this._opts.detail.id,
			source: this._opts.detail.source,
			typeid: this._opts.detail.typeId,
			index: this._opts.index,
			section: "reviews",
			...data,
			...this._opts.analytics,
		};
	}

	_log(name: string, data: object) {
		Mapy.getComponent("logger").log(name, this._getLogData(data));
	}
}
